<mat-form-field appearance="outline" floatLabel="always" class="form-field" [class.disabled]="disabled" [class.highlighted]="highlighted">
  <mat-select
    [multiple]="multiple"
    disableOptionCentering
    panelClass="dropdown-panel"
    [placeholder]="placeholder"
    [compareWith]="compareOptions"
    [value]="selected"
    (valueChange)="updateSelected($event)"
    (openedChange)="openedChange($event)"
    class="select-option"
    >
    @for (option of options; track option) {
      <mat-option [value]="option" [disabled]="disabledOptions && disabledOptions.length > 0 && isDisabled(option)">
        <p class="select-option" [matTooltip]="option.title" [matTooltipShowDelay]="1000" [matTooltipDisabled]="!tooltip">{{option.title}}</p>
      </mat-option>
    }
  </mat-select>
  <!-- <mat-icon matSuffix svgIcon="arrow"></mat-icon> -->
</mat-form-field>
